var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxoutlineuserStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.8C0 2.6 2.6 0 5.8 0C9 0 11.6 2.6 11.6 5.8C11.6 9 9 11.6 5.8 11.6C2.6 11.6 0 9 0 5.8C0 5.8 0 5.8 0 5.8ZM1.6 5.8C1.6 8.1 3.5 10 5.8 10C8.1 10 10 8.1 10 5.8C10 3.5 8.1 1.6 5.8 1.6C3.5 1.6 1.6 3.5 1.6 5.8C1.6 5.8 1.6 5.8 1.6 5.8Z",
    transform: "translate(6.2 1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.8C0 3.5 4.2 0 9.3 0C9.7 0 10 0.3 10 0.8C10 1.3 9.7 1.6 9.3 1.6C5 1.6 1.5 4.4 1.5 7.8C1.5 8.2 1.2 8.6 0.8 8.6C0.4 8.6 0 8.2 0 7.8C0 7.8 0 7.8 0 7.8Z",
    transform: "translate(2.7 14.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 1.6C0.400001 1.6 0 1.3 0 0.799999C0 0.299999 0.3 0 0.8 0C0.8 0 6.8 0 6.8 0C7.2 0 7.6 0.299999 7.6 0.799999C7.6 1.3 7.3 1.6 6.8 1.6C6.8 1.6 0.8 1.6 0.8 1.6C0.8 1.6 0.8 1.6 0.8 1.6Z",
    transform: "translate(15.2 18.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 1.6C0.400001 1.6 0 1.3 0 0.8C0 0.299999 0.3 0 0.8 0C0.8 0 6.8 0 6.8 0C7.2 0 7.6 0.3 7.6 0.8C7.6 1.3 7.3 1.6 6.8 1.6C6.8 1.6 0.8 1.6 0.8 1.6C0.8 1.6 0.8 1.6 0.8 1.6Z",
    transform: "translate(15.2 15.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 1.6C0.400001 1.6 0 1.3 0 0.799999C0 0.299999 0.3 0 0.8 0C0.8 0 3.8 0 3.8 0C4.2 0 4.6 0.299999 4.6 0.799999C4.6 1.3 4.3 1.6 3.8 1.6C3.8 1.6 0.8 1.6 0.8 1.6C0.8 1.6 0.8 1.6 0.8 1.6Z",
    transform: "translate(15.2 21.1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlineuserStatus);
export default __webpack_public_path__ + "static/media/vuesaxoutlineuser-status.39139edf7c6fa690c0239ed1a55c292c.svg";
export { ForwardRef as ReactComponent };